import React from "react";

import { Link, useParams } from "react-router-dom";
import {Badge, Button, Card, CardBody, CardFooter, CardHeader,Col,Container,Row} from "reactstrap";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { H5, H6 } from "../../../AbstractElements";
import { SMSData } from "../../../component/master-settings/sms-gateway/SMS";

interface InfoRowProps {
  label: string;
  value: React.ReactNode; 
  isLink?: boolean;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value, isLink = false }) => (
  <Row className="py-3 border-bottom-light">
    <Col sm={4} className="text-muted">
      {label}
    </Col>
    <Col sm={8} className="fw-semibold text-break">
      {isLink && typeof value === "string" ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ) : (
        value
      )}
    </Col>
  </Row>
);


function ViewSmsGateway() {
  const { t } = useTranslation();
  const { id } = useParams();

  const gatewayDetails = SMSData.find(
    (gateway) => gateway.sms_gateway_id === parseInt(id || "0")
  );


  if (!gatewayDetails) {
    return (
      <div className="page-body">
        <Breadcrumbs
          mainTitle={t("Gateway Not Found")}
          parents={[{ label: "MasterSettings" }]}
        />
        <Container fluid>
          <Card className="mt-4 text-center p-5">
            <H5>SMS Gateway with ID '{id}' was not found.</H5>
            <p className="text-muted">
              Please check the ID or return to the list.
            </p>
            <div className="mt-3">
              <Link to={`${process.env.PUBLIC_URL}/mastersettings/smsgateway`}>
                <Button color="primary">
                  <i className="fa fa-arrow-left me-2"></i>
                  Back to List
                </Button>
              </Link>
            </div>
          </Card>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={t("View SMS Gateway")}
        parents={[
          { label: "MasterSettings" },
          {
            label: t("SMSGateway"),
            link: `${process.env.PUBLIC_URL}/mastersettings/smsgateway`,
          },
        ]}
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={12}>
            <Card className="shadow-lg mt-4">
              <CardHeader className="d-flex justify-content-between align-items-center bg-light p-3">
                <H5 className="mb-0 d-flex align-items-center">
                 
                  {gatewayDetails.sms_gateway_name}
                </H5>
              
              
              </CardHeader>
              <CardBody className="p-4">
                <Row>
                 
                  <Col lg={8} className="border-end-lg">
                    <H6 className="mb-3 text-muted">Key Links & Information</H6>
                    <InfoRow
                      label="API URL"
                      value={gatewayDetails.sms_gateway_url}
                      isLink
                    />
                    <InfoRow
                      label="Sign-up URL"
                      value={gatewayDetails.sms_gateway_signup_url}
                      isLink
                    />
                    <InfoRow
                      label="Recharge URL"
                      value={gatewayDetails.sms_gateway_recharge_url}
                      isLink
                    />
                    <InfoRow
                      label="Method"
                      value={
                        <Badge
                          color={
                            gatewayDetails.Method?.toLowerCase() === "live"
                              ? "success"
                              : "warning"
                          }
                          pill
                          className="text-white"
                        >
                          {gatewayDetails.Method}
                        </Badge>
                      }
                    />
                    <InfoRow
                      label="Provider Name"
                      value={gatewayDetails.provider_name}
                    />
                    <InfoRow label="Gateway Type" value={gatewayDetails.type} />
                    <InfoRow
                      label="Request Format"
                      value={gatewayDetails.sms_gateway_request_format}
                    />
                        <InfoRow
                      label="Status"
                      value={
                        <span
                          className={
                            gatewayDetails.status === "Default"
                              ? "text-success fw-bold"
                              : "text-danger fw-bold"
                          }
                        >
                          {gatewayDetails.status}
                        </span>
                      }
                    />
                  </Col>
                
                </Row>
              </CardBody>
              <CardFooter className="text-end  border-0 p-3">
                <Link
                  to={`${process.env.PUBLIC_URL}/mastersettings/smsgateway`}
                >
                  <Button color="secondary" outline className="me-2">
                    Back to List
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ViewSmsGateway;
